import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 1,
  class: "col-12 mt-1 p-error vp-font-small"
}
const _hoisted_3 = { class: "formgrid grid" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "formgroup-inline justify-content-center" }
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 0,
  class: "col-12 mt-1 p-error vp-font-small"
}
const _hoisted_8 = { class: "formgrid grid" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = ["for"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "w-full my-0 vp-label font-light vp-font-small vp-variant mt-1" }
const _hoisted_14 = {
  key: 0,
  class: "col-12 mt-1 p-error vp-font-small"
}
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "grid mb-2" }
const _hoisted_17 = {
  key: 0,
  class: "col-12 vp-variant vp-font-small"
}
const _hoisted_18 = {
  key: 1,
  class: "col-12 vp-variant vp-font-small"
}
const _hoisted_19 = { class: "formgrid grid" }
const _hoisted_20 = { class: "formgrid grid" }
const _hoisted_21 = {
  key: 0,
  class: "col-12 p-error text-right font-bold vp-font-small mb-5"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right vp-font-small" }, null, -1)
const _hoisted_23 = { class: "formgrid grid" }
const _hoisted_24 = { class: "col-4" }
const _hoisted_25 = { class: "formgrid grid vp-input-container" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "col-3" }
const _hoisted_28 = { class: "col-5" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = {
  key: 0,
  class: "mt-2 p-error col-12 vp-font-small"
}
const _hoisted_31 = {
  key: 1,
  class: "mt-2 p-error col-12 vp-font-small"
}
const _hoisted_32 = { class: "formgrid grid vp-input-container" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = {
  key: 0,
  class: "mt-2 p-error col-12 vp-font-small"
}
const _hoisted_37 = { class: "formgrid grid vp-input-container" }
const _hoisted_38 = {
  key: 0,
  class: "col-12"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "vp-variant vp-font-small" }
const _hoisted_41 = { class: "col-12 field-checkbox" }
const _hoisted_42 = { class: "field-checkbox col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_hgroup = _resolveComponent("a-hgroup")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_password = _resolveComponent("a-password")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
    class: "p-fluid"
  }, [
    _createVNode(_component_a_input, {
      name: "club",
      title: "general.club",
      modelValue: _ctx.v$.club,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.club) = $event)),
      class: "col-12"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_a_hgroup, {
      heading: _ctx.$t('forms.motivations.heading.club'),
      subheading: _ctx.$t('forms.motivations.subheading'),
      variant: ""
    }, null, 8, ["heading", "subheading"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaults.motivations, (motivation, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `motivation-${ index }`,
        class: "field-checkbox"
      }, [
        (_openBlock(), _createBlock(_component_checkbox, {
          id: motivation,
          name: "motivation",
          key: motivation,
          value: motivation,
          modelValue: _ctx.v$.motivations.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.motivations.$model) = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOptions()))
        }, null, 8, ["id", "value", "modelValue"])),
        _createElementVNode("label", { for: motivation }, _toDisplayString(_ctx.$t(`forms.motivations.${motivation}`)), 9, _hoisted_1)
      ]))
    }), 128)),
    (_ctx.showExtra)
      ? (_openBlock(), _createBlock(_component_a_input, {
          key: 0,
          name: "extra",
          title: "general.extra",
          modelValue: _ctx.v$.extra,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.extra) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.v$.motivations.$error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t(`forms.motivations.error.required`)), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_hgroup, {
      heading: _ctx.$t('forms.size.heading'),
      variant: ""
    }, null, 8, ["heading"]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("section", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaults.size, (size, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `size-${i}`,
              class: "field-radiobutton"
            }, [
              _createVNode(_component_radio_button, {
                name: "size",
                id: size,
                value: size,
                modelValue: _ctx.v$.size.$model,
                "onUpdate:modelValue": ($event: any) => ((_ctx.v$.size.$model) = $event)
              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue"]),
              _createElementVNode("label", { for: size }, _toDisplayString(_ctx.$t(`forms.size.${size}`)), 9, _hoisted_6)
            ]))
          }), 128)),
          (_ctx.v$.size.$error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t(`forms.size.error.required`)), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_a_hgroup, {
      heading: _ctx.$t('forms.locales.heading'),
      subheading: _ctx.$t('forms.locales.subheading'),
      variant: ""
    }, null, 8, ["heading", "subheading"]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_dropdown, {
          optionValue: "key",
          optionLabel: ({ translation }) => _ctx.$t(translation),
          modelValue: _ctx.v$.currentLocale.$model,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.currentLocale.$model) = $event)),
          options: _ctx.defaults.locales
        }, null, 8, ["optionLabel", "modelValue", "options"])
      ]),
      _createVNode(_component_a_input, {
        class: "col-4",
        title: "general.postcode",
        name: "postcode",
        modelValue: _ctx.v$.postcodeInput,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.postcodeInput) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_a_hgroup, {
        heading: _ctx.$t('forms.tasks.heading.organisation'),
        variant: ""
      }, null, 8, ["heading"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaults.tasks, (task, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "field-checkbox align-items-start"
        }, [
          (_openBlock(), _createBlock(_component_checkbox, {
            id: task,
            name: "tasks",
            key: task,
            value: task,
            modelValue: _ctx.v$.tasks.$model,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.tasks.$model) = $event))
          }, null, 8, ["id", "value", "modelValue"])),
          _createElementVNode("label", { for: task }, [
            _createTextVNode(_toDisplayString(_ctx.$t(`forms.tasks.${task}.main`)), 1),
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(`forms.tasks.${task}.sub`)), 1)
          ], 8, _hoisted_11)
        ]))
      }), 128)),
      (_ctx.v$.tasks.$error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t(`forms.tasks.error.required`)), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_divider, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("registration.group.divider")), 1)
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaults.responsible, (who) => {
      return (_openBlock(), _createElementBlock("div", {
        key: who,
        class: "field-radiobutton"
      }, [
        _createVNode(_component_radio_button, {
          id: who,
          name: who,
          value: who,
          modelValue: _ctx.v$.responsible.$model,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.responsible.$model) = $event)),
          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setOptions()))
        }, null, 8, ["id", "name", "value", "modelValue"]),
        _createElementVNode("label", { for: who }, _toDisplayString(_ctx.$t(`forms.responsible.${who}.title`)), 9, _hoisted_15)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_16, [
      (!_ctx.showVReg)
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t(`forms.responsible.other.info`)), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t(`forms.responsible.me.info`)), 1))
    ]),
    (_ctx.showVReg)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_a_input, {
              class: "col-6",
              title: "general.firstname",
              name: "firstname",
              modelValue: _ctx.v$.firstname,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.firstname) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_a_input, {
              class: "col-6",
              title: "general.lastname",
              name: "lastname",
              modelValue: _ctx.v$.lastname,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.lastname) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_a_input, {
              name: "email",
              title: "general.email",
              class: _normalizeClass({
            'col-12': true,
            'mb-0': _ctx.isNotUnique() && !_ctx.isAuthenticated,
          }),
              disabled: _ctx.isAuthenticated,
              modelValue: _ctx.v$.emailInput,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.emailInput) = $event))
            }, null, 8, ["class", "disabled", "modelValue"]),
            (_ctx.isNotUnique() && !_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("a", {
                    onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
                    href: "#"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`cta.email`)) + " ", 1),
                    _hoisted_22
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_a_password, {
                key: 0,
                modelValue: _ctx.v$.password,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.password) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_dropdown, {
                modelValue: _ctx.v$.phonePrefix.$model,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.v$.phonePrefix.$model) = $event)),
                optionLabel: "code",
                optionValue: "code",
                options: _ctx.defaults.phonePrefix
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode(_component_a_input, {
              class: "col-8",
              name: "tel",
              title: "general.tel",
              modelValue: _ctx.v$.tel,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.tel) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("section", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_a_hgroup, {
                heading: _ctx.$t('forms.birthdate.heading'),
                variant: ""
              }, null, 8, ["heading"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_dropdown, {
                class: _normalizeClass([{ 'vp-dropdown-error': _ctx.v$.day.$error }, "vp-dropdown-p1"]),
                name: "day",
                modelValue: _ctx.v$.day.$model,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.day.$model) = $event)),
                placeholder: _ctx.$t('general.days'),
                options: _ctx.defaults.days,
                onBlur: _ctx.setBirthDate
              }, null, 8, ["class", "modelValue", "placeholder", "options", "onBlur"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_dropdown, {
                name: "months",
                class: _normalizeClass({ 'vp-dropdown-error': _ctx.v$.day.$error }),
                placeholder: _ctx.$t('general.months'),
                modelValue: _ctx.v$.month.$model,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.v$.month.$model) = $event)),
                optionLabel: "name",
                optionValue: "code",
                options: _ctx.defaults.months,
                onBlur: _ctx.setBirthDate
              }, null, 8, ["class", "placeholder", "modelValue", "options", "onBlur"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_dropdown, {
                name: "years",
                class: _normalizeClass({ 'vp-dropdown-error': _ctx.v$.day.$error }),
                modelValue: _ctx.v$.year.$model,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.v$.year.$model) = $event)),
                placeholder: _ctx.$t('general.years'),
                options: _ctx.defaults.years,
                onBlur: _ctx.setBirthDate
              }, null, 8, ["class", "modelValue", "placeholder", "options", "onBlur"])
            ]),
            (_ctx.showAgeError())
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.$t(`forms.birthdate.errors.age`)), 1))
              : (_ctx.v$.birthdate.$dirty && _ctx.v$.birthdate.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t(`forms.birthdate.errors.required`)), 1))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("section", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_a_hgroup, {
                heading: _ctx.$t('forms.location.heading'),
                variant: ""
              }, null, 8, ["heading"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_dropdown, {
                class: _normalizeClass({ 'vp-dropdown-error': _ctx.v$.country.$error }),
                modelValue: _ctx.v$.country.$model,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.v$.country.$model) = $event)),
                optionValue: "name",
                optionLabel: "name",
                placeholder: _ctx.$t('general.country'),
                options: _ctx.defaults.countries
              }, null, 8, ["class", "modelValue", "placeholder", "options"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_dropdown, {
                class: _normalizeClass({ 'vp-dropdown-error': _ctx.v$.language.$error }),
                modelValue: _ctx.v$.language.$model,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.v$.language.$model) = $event)),
                placeholder: _ctx.$t('general.language'),
                options: _ctx.defaults.language
              }, null, 8, ["class", "modelValue", "placeholder", "options"])
            ]),
            (_ctx.v$.country.$error || _ctx.v$.language.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.$t(`forms.location.error.required`)), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_Textarea, {
            class: _normalizeClass({
          'vp-input-container': true,
          'vp-variant': !_ctx.updateRemark,
        }),
            placeholder: _ctx.defaults.remarks,
            modelValue: _ctx.updateRemark,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.updateRemark) = $event)),
            autoResize: true,
            rows: "5",
            cols: "30"
          }, null, 8, ["class", "placeholder", "modelValue"]),
          _createElementVNode("div", _hoisted_37, [
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("img", { src: _ctx.logo }, null, 8, _hoisted_39),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("forms.warning")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_checkbox, {
                id: "terms",
                modelValue: _ctx.v$.terms.$model,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.v$.terms.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.terms.$invalid }),
                binary: true
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("label", {
                for: "terms",
                class: _normalizeClass({ 'p-error': _ctx.v$.terms.$invalid })
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("forms.terms.prefix")) + " ", 1),
                _createElementVNode("button", {
                  class: "inline p-0 vp-font-small p-link font-bold",
                  onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.navigateToTerms()), ["prevent"]))
                }, _toDisplayString(_ctx.$t("forms.terms.link")), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_checkbox, {
                class: _normalizeClass({ 'p-invalid': _ctx.v$.privacy.$invalid }),
                id: "privacy",
                modelValue: _ctx.v$.privacy.$model,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.v$.privacy.$model) = $event)),
                binary: true
              }, null, 8, ["class", "modelValue"]),
              _createElementVNode("label", {
                class: _normalizeClass({ 'p-error': _ctx.v$.privacy.$invalid }),
                for: "privacy"
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("forms.privacy.prefix")) + " ", 1),
                _createElementVNode("button", {
                  class: "inline p-0 vp-font-small p-link font-bold",
                  onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.navigateToPrivacy()), ["prevent"]))
                }, _toDisplayString(_ctx.$t("forms.privacy.link")), 1)
              ], 2)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_Button, {
      loading: _ctx.isProcessing,
      class: "vp-button font-bold",
      type: "submit",
      disabled: 
        !_ctx.v$.$anyDirty ||
        _ctx.v$.$errors.length > 0 ||
        !_ctx.v$.privacy.$model ||
        !_ctx.v$.terms.$model
      ,
      label: _ctx.$t('cta.register')
    }, null, 8, ["loading", "disabled", "label"])
  ], 32))
}